import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PasswordChangeService } from './password-change.service';
import { Router } from '@angular/router';

@Component({
    selector: 'password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.css'],
    standalone: false
})
export class PasswordChangeComponent {
  public passwordChangeForm: UntypedFormGroup;

  constructor(private service: PasswordChangeService, private router: Router) {
    this.passwordChangeForm = new UntypedFormGroup({
      oldpass: new UntypedFormControl(null, [Validators.required]),
      newpass: new UntypedFormControl(null, [Validators.required]),
      repeatpass: new UntypedFormControl(null, [Validators.required])
    });
  }

  private validateForm() {
    this.service.errorMessages = [];
    if (this.passwordChangeForm.get('oldpass')?.invalid && this.passwordChangeForm.get('oldpass')?.errors?.['required']) {
      this.service.errorMessages.push('Old Password is required');
    }
    if (this.passwordChangeForm.get('newpass')?.invalid && this.passwordChangeForm.get('newpass')?.errors?.['required']) {
      this.service.errorMessages.push('New Password is required');
    }
    if (this.passwordChangeForm.get('repeatpass')?.invalid && this.passwordChangeForm.get('repeatpass')?.errors?.['required']) {
      this.service.errorMessages.push('Repeat Password is required');
    }
    if (this.formValid && this.passwordChangeForm.get('newpass')?.value != this.passwordChangeForm.get('repeatpass')?.value) {
      this.service.errorMessages.push('New passwords differ');
    }
  }

  get formValid() {
    return this.service.errorMessages.length == 0;
  }

  get errorMessages(): string[] {
    return this.service.errorMessages;
  }

  submitClicked() {
    this.validateForm();
    if (this.formValid) {
      this.service.changePassword(this.passwordChangeForm.get('oldpass')?.value, this.passwordChangeForm.get('newpass')?.value);
      this.exit();
    }
  }

  cancelClicked() {
    this.passwordChangeForm.get('oldpass')?.reset();
    this.passwordChangeForm.get('newpass')?.reset();
    this.passwordChangeForm.get('repeatpass')?.reset();
    this.service.errorMessages = [];
    this.exit();
  }

  get user() {
    return this.service.user;
  }

  private exit() {
    this.router.navigate(['']);
  }
}